import CopilotImg from '../media/copilot.png';
import PerformanceImg from '../media/performance.png';
import ImportImg from '../media/import.png';

export const FeatureConfig = [{
  key: 'copilot',
  title: _TL_('Increase efficiency with your own advertising AI assistant'),
  description: _TL_('Copilot in the Microsoft Advertising Platform is your everyday AI assistant for creating high-quality marketing easily and efficiently, guiding you through campaign creation, asset recommendation, and answering questions along the way.'),
  imageSrc: CopilotImg,
}, {
  key: 'performance',
  title: _TL_('Boost campaign performance and ROAS'),
  description: _TL_('Insights gained from analyzing your performance enables you to enhance and optimize campaigns, connect the right message with the right customer, and achieve greater returns on your time and advertising dollars.'),
  imageSrc: PerformanceImg,
}, {
  key: 'import',
  title: _TL_('Jumpstart performance and save time with Import tools​'),
  description: _TL_('Expand the reach of your existing Meta and Google ads and save time by importing your campaigns into Microsoft Advertising through our convenient Import tools.'),
  imageSrc: ImportImg,
}];
